<template>
    <modal :show="show" class="white-content" @update:show="$emit('update:show', $event)">
      <h3 style="margin-bottom: 0px;" class="card-title">{{ $t('tools.reserveTool') }}</h3>
      <h4>{{ $t('tools.available') }}: {{ availableToolsInMultiTool }}</h4>
      <div class="row">
        <div :class="userRole !== 'User' ? 'col-6' : 'col-12'">
          <label class="col-md-4 col-form-label toolgroup-modal-label">{{ $t('tools.quantity') }} *</label>
          <material-input
            id="multiToolQuantity"
            v-model:value="quantityString"
            :placeholder="$t('tools.quantity')"
          />
        </div>
        <div v-if="userRole !== 'User'" class="col-6">
          <label class="col-md-4 col-form-label toolgroup-modal-label">{{ $t('tools.reservationType') }} *</label>
          <el-select v-model="localMultiToolReservationType" class="form-control" :placeholder="$t('tools.reservationType')">
            <el-option
              v-for="(status, index) in multiToolReservationTypeOptions"
              :key="index"
              :value="status"
              :label="status"
            />
          </el-select>
        </div>
      </div>
      <div v-if="userRole !== 'User'" class="row">
        <div v-if="localMultiToolReservationType !== $t('tools.reserve')" class="col-6">
          <label class="col-md-4 col-form-label toolgroup-modal-label">{{ $t('tools.loanRentTo') }} *</label>
          <material-input
            id="multiToolLoanRentExternalUser"
            v-model:value="localMultiToolLoanRentExternalUser"
            :placeholder="$t('tools.loanRentTo')"
          />
          <label class="col-md-4 col-form-label toolgroup-modal-label">{{ $t('tools.loanRentToEmail') }}</label>
          <material-input
            id="multiToolLoanRentExternalUserEmail"
            v-model:value="localMultiToolLoanRentExternalUserEmail"
            :placeholder="$t('users.email')"
          />
        </div>
        <div v-if="localMultiToolReservationType === $t('tools.rent')" class="col-6">
          <label class="col-md-4 col-form-label toolgroup-modal-label">{{ $t('tools.dailyPrice') }}</label>
          <material-input
            id="multiToolLoanRentDailyPrice"
            v-model:value="dailyPriceString"
            :placeholder="$t('tools.dailyPrice')"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-sm d-flex justify-content-end">
          <material-button type="standard" fill @click="$emit('submit')">{{ $t('common.submit') }}</material-button>
        </div>
      </div>
    </modal>
  </template>
  
  <script>
  import { ElSelect, ElOption } from 'element-plus';
  import Modal from './Modal.vue';
  import MaterialInput from '../MaterialInput.vue';
  import MaterialButton from '../MaterialButton.vue';
  
  export default {
    components: { Modal, MaterialInput, MaterialButton, ElSelect, ElOption },
    props: {
      show: { type: Boolean, required: true },
      availableToolsInMultiTool: { type: [String, Number], required: true },
      multiToolQuantity: { type: [String, Number], required: true },
      multiToolReservationType: { type: String, required: true },
      multiToolLoanRentExternalUser: { type: String, required: true },
      multiToolLoanRentExternalUserEmail: { type: String, required: true },
      multiToolLoanRentDailyPrice: { type: [String, Number], required: true },
      multiToolReservationTypeOptions: { type: Array, required: true },
      userRole: { type: String, required: true }
    },
    emits: ['update:show', 'update:multiToolQuantity', 'update:multiToolReservationType', 'update:multiToolLoanRentExternalUser', 'update:multiToolLoanRentExternalUserEmail', 'update:multiToolLoanRentDailyPrice', 'submit'],
    data() {
      return {
        localMultiToolQuantity: this.multiToolQuantity,
        localMultiToolReservationType: this.multiToolReservationType,
        localMultiToolLoanRentExternalUser: this.multiToolLoanRentExternalUser,
        localMultiToolLoanRentExternalUserEmail: this.multiToolLoanRentExternalUserEmail,
        localMultiToolLoanRentDailyPrice: this.multiToolLoanRentDailyPrice
      };
    },
    computed: {
      quantityString: {
        get() {
          return this.localMultiToolQuantity !== '' ? this.localMultiToolQuantity.toString() : '';
        },
        set(val) {
          this.localMultiToolQuantity = val ? Number(val) : '';
          this.$emit('update:multiToolQuantity', this.localMultiToolQuantity);
        }
      },
      dailyPriceString: {
        get() {
          return this.localMultiToolLoanRentDailyPrice !== '' ? this.localMultiToolLoanRentDailyPrice.toString() : '';
        },
        set(val) {
          this.localMultiToolLoanRentDailyPrice = val ? Number(val) : '';
          this.$emit('update:multiToolLoanRentDailyPrice', this.localMultiToolLoanRentDailyPrice);
        }
      }
    },
    watch: {
      show(newVal) {
        if (newVal) {
          this.localMultiToolQuantity = this.multiToolQuantity;
          this.localMultiToolReservationType = this.multiToolReservationType;
          this.localMultiToolLoanRentExternalUser = this.multiToolLoanRentExternalUser;
          this.localMultiToolLoanRentExternalUserEmail = this.multiToolLoanRentExternalUserEmail;
          this.localMultiToolLoanRentDailyPrice = this.multiToolLoanRentDailyPrice;
        }
      },
      localMultiToolReservationType(newVal) { this.$emit('update:multiToolReservationType', newVal); },
      localMultiToolLoanRentExternalUser(newVal) { this.$emit('update:multiToolLoanRentExternalUser', newVal); },
      localMultiToolLoanRentExternalUserEmail(newVal) { this.$emit('update:multiToolLoanRentExternalUserEmail', newVal); }
    }
  };
  </script>
  
  <style scoped>
  .toolgroup-modal-label {
    padding-left: 0px;
  }
  </style>